import { render } from "./ProjectsMap.vue?vue&type=template&id=83383f76&scoped=true"
import script from "./ProjectsMap.vue?vue&type=script&lang=js"
export * from "./ProjectsMap.vue?vue&type=script&lang=js"

import "../styles/digital-map-project.scss?vue&type=style&index=0&id=83383f76&scoped=true&lang=scss"
import "../styles/map-block.scss?vue&type=style&index=1&id=83383f76&scoped=true&lang=scss"
import "./ProjectsMap.vue?vue&type=style&index=2&id=83383f76&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83383f76"]])

export default __exports__